"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimMessage = exports.ClaimStatus = void 0;
var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["All"] = "0";
    ClaimStatus["Dispensed"] = "5dispensed";
    ClaimStatus["Error"] = "1error";
    ClaimStatus["Intended"] = "9intended";
    ClaimStatus["New"] = "6new";
    ClaimStatus["Paid"] = "4paid";
    ClaimStatus["Refill"] = "0refill";
    ClaimStatus["RefillDelayed"] = "0refillDelayed";
    ClaimStatus["RefillDone"] = "8refillDone";
    ClaimStatus["Refilled"] = "7refilled";
    ClaimStatus["Reversed"] = "3reversed";
    ClaimStatus["ReverseError"] = "2reverseError";
    ClaimStatus["ReverseErrorDev"] = "2reverseErrorDev";
})(ClaimStatus = exports.ClaimStatus || (exports.ClaimStatus = {}));
var ClaimMessage;
(function (ClaimMessage) {
    ClaimMessage["ProfitMarginRejected"] = "Profit margin rejected";
    ClaimMessage["CopayRejected"] = "Copay rejected";
})(ClaimMessage = exports.ClaimMessage || (exports.ClaimMessage = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/claim.ts
// module id = 159
// module chunks = 0 1